<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <!-- <div class="col-sm-12"> -->
          <div class="row"></div>
        </div>
        <div class="question-bank-row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-lg-7 col-xl-8 create-question-scroll">
                <div class="heading mt-3">
                  <div class="col-sm-12">
                    <vs-breadcrumb
                      align="left"
                      :items="
                        [
                          {title: 'You are here : '},
                          {
                            title: 'Dashboard',
                            url: '/#/dashboard/Admin/adminDashboard'
                          },
                          {
                            title: 'Add Trainer',
                            url: '/#/dashboard/Admin/addTrainer',
                            active: true
                          }
                        ]"
                    ></vs-breadcrumb>
                  </div>
                  <h3 class="text-secondary text-left">
                    Facilitators / Trainers
                  </h3>
                </div>
                <b-card>
                  
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="table-responsive">
                          <input
                        type="text"
                        placeholder="Search ..."
                        v-model="searchQuery"
                        class="search_button form-control"
                        @keyup.enter="filterData"
                        @input="callSearch"
                      />
                      <button class="search2" @click="allTrainer">
                        Search
                      </button>
                      <i
                        v-if="searchQuery !== ''"
                        class="material-icons close_icon2"
                        @click="clearSearch"
                        >close</i
                      >
                      <Pagination
                        :current-page="currentPage"
                        :record-limit="recordLimit"
                        :total-counts="totalCounts"
                        @prev-page="prevPage"
                        @next-page="nextPage"
                        @go-to-page="goToPage"
                      />
                      <div class="page-count">
                        {{((currentPage-1)*50)+items.length}}
                        Records out of
                        {{this.totalCounts}}
                      </div>
                          <table class="table table-hover">
                            <tr>
                              <th>Sr#</th>
                              <th>Name</th>
                              <th>Code</th>
                              <th>CNIC Number</th>
                              <th>Contact</th>
                              <th>Email</th>
                              <th>Action</th>
                            </tr>
                            <tr
                              v-for="(item, index) in items"
                              v-bind:key="item.id"
                            >
                              <td>{{index + 1 + offSet}}</td>
                              <td
                                v-if="item.name != null"
                                class="text-capitalize"
                              >
                                {{item.name}}
                              </td>
                              <td v-else>NULL</td>
                              <td v-if="item.trainer_user_id.code != null">
                                {{item.trainer_user_id.code}}
                              </td>
                              <td v-else>NULL</td>
                              <td v-if="item.cnic != null">{{item.cnic}}</td>
                              <td v-else>NULL</td>
                              <td v-if="item.trainer_user_id.contactNo != null">
                                {{item.trainer_user_id.contactNo}}
                              </td>
                              <td v-else>NULL</td>
                              <td v-if="item.trainer_user_id.username != null">
                                {{item.trainer_user_id.username}}
                              </td>
                              <td v-else>NULL</td>
                              <td>
                                <a @click="editRecord(item.id)">
                                  <vs-icon
                                    class="mr-1"
                                    icon="edit"
                                    style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                                <a @click="deleteRecord(item.id)">
                                  <vs-icon
                                    class="mr-1"
                                    icon="delete"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div
                class="col-lg-5 col-xl-4 order-first order-lg-2 show-question-scroll create-right"
              >
                <template v-if="isForm">
                  <h6 class="mt-4 mb-4">Add New Facilitator</h6>
                  <form @submit.prevent="quickRegistration">
                    <div>
                      <div class="row">
                        <!--Detail Information starts -->
                        <div class="form-group">
                          <div class="row col-sm-12">
                            <div class="col-sm-6 col-lg-12">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  type="text"
                                  placeholder=" "
                                  v-model="name"
                                  @input="name = name.replace(/[^a-zA-Z\s]/g, '')"
                                  id="name"
                                />
                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >account_circle</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Name
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>

                            <div class="col-sm-6 mt-3 col-lg-12">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(9999)-9999999'"
                                  type="text"
                                  placeholder=" "
                                  v-model="mobilenumber"
                                  id="contact_no"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >call</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Contact
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-3 col-lg-12">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="passport"
                                  type="text"
                                  placeholder=" "
                                  id="passport"
                                />
                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >credit_card</i
                                  >
                                </span>
                                <label class="lbl-label"> Passport </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-3 col-lg-12">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  type="text"
                                  placeholder=""
                                  v-model="address"
                                  id="address"
                                />

                                <span
                                  class="lbl-label"
                                  style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          "
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px"
                                    >home</i
                                  >
                                </span>
                                <label class="lbl-label"> Address </label>
                              </div>
                            </div>

                            <div class="col-sm-6 mt-3 col-lg-12">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  type="email"
                                  placeholder=" "
                                  v-model="email"
                                  id="email"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >email</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Email
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <div class="col-md-6 col-lg-12 mt-2">
                              <div class="form-group">
                                <label style="font-weight: 700" for="first">
                                  Nationality
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                                <selectize
                                  id="select-state nationality"
                                  class="text-capitalize"
                                  v-model="nationality"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in nationalityArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                  >
                                    {{item.name}}
                                  </option>
                                </selectize>
                              </div>
                            </div>
                            <div class="col-sm-6 col-lg-12 ">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(99999) 9999999-9'"
                                  type="text"
                                  placeholder=" "
                                  v-model="cnic"
                                  :disabled="nationality != 1"
                                  id="cnic"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >credit_card</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  CNIC Number
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <div class="col-md-6 col-lg-12 mt-2">
                              <div class="form-group">
                                <label style="font-weight: 700" for="first">
                                  Qualification
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                                <selectize
                                  id="select-state qualification"
                                  class="text-capitalize"
                                  v-model="academicqualifications"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in qualificationArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                  >
                                    {{item.title}}
                                  </option>
                                </selectize>
                              </div>
                            </div>
                            <div class="col-md-6 col-lg-12">
                              <div class="form-group">
                                <label style="font-weight: 700" for="first">
                                  Department
                                </label>
                                <selectize
                                  id="select-state department"
                                  class="text-capitalize"
                                  v-model="department"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in departmentArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                  >
                                    {{item.title}}
                                  </option>
                                </selectize>
                              </div>
                            </div>
                            <div class="col-md-6 col-lg-12">
                              <div class="form-group">
                                <label style="font-weight: 700" for="first">
                                  Designation
                                </label>
                                <selectize
                                  id="select-state designation"
                                  class="text-capitalize"
                                  v-model="designation"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in designationArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                  >
                                    {{item.title}}
                                  </option>
                                </selectize>
                              </div>
                            </div>

                            <div class="col-md-6 col-lg-12">
                              <!-- Gender starts -->
                              <div
                                style="padding-left: 5px;display: inline-flex;"
                              >
                                <label class="col-form-label">
                                  Gender
                                  <span style="color:rgba(255, 0, 0, 0.78)"
                                    >*</span
                                  >
                                </label>
                                <div style="margin: 7px 6px 2px 6px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="male"
                                    id="male"
                                    >Male</vs-radio
                                  >
                                </div>
                                <div style="margin: 7px 6px 2px 6px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="female"
                                    id="female"
                                    >Female</vs-radio
                                  >
                                </div>
                                <div style="margin: 7px 6px 2px 6px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="rather not say"
                                    id="gender"
                                    >Rather not say</vs-radio
                                  >
                                </div>
                              </div>
                              <!-- Gender ends -->
                            </div>
                            <div class="col-md-6 col-lg-12 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="code"
                                  type="text"
                                  placeholder=" "
                                  id="code"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >code</i
                                  >
                                </span>
                                <label class="lbl-label">
                                  Employee Code (This will use as password)
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 col-lg-12 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  hidden
                                  type="text"
                                  placeholder=" "
                                  v-model="role"
                                  id="role"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                ></span>

                                <!-- save button starts-->
                                <b-button
                                  type="submit"
                                  class="save-btn"
                                  variant="primary"
                                  >Save</b-button
                                >
                                <!-- save button ends -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--Detail Information ends -->
                      </div>
                    </div>
                  </form>
                </template>
                <!-- Edit form starts here -->
                <template v-if="isEditForm">
                  <h6 class="mt-4 mb-4">Edit Facilitator</h6>
                  <form @submit.prevent="submitEditForm">
                    <div class="form-group">
                      <div class="row">
                        <!-- floating input starts -->
                        <div class="col-sm-6 col-lg-12">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              type="text"
                              placeholder=" "
                              v-model="name"
                              @input="name = name.replace(/[^a-zA-Z\s]/g, '')"
                              id="name"
                            />
                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >account_circle</i
                              >
                            </span>
                            <label class="lbl-label">
                              Name
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                          </div>
                        </div>

                        <div class="col-sm-6 mt-3 col-lg-12">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              v-mask="'(9999)-9999999'"
                              type="text"
                              placeholder=" "
                              v-model="mobilenumber"
                              id="contact_no"
                            />

                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >call</i
                              >
                            </span>
                            <label class="lbl-label">
                              Contact
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-6 mt-3 col-lg-12">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              v-model="passport"
                              type="text"
                              placeholder=" "
                              id="passport"
                            />
                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >credit_card</i
                              >
                            </span>
                            <label class="lbl-label"> Passport </label>
                          </div>
                        </div>
                        <div class="col-sm-6 mt-3 col-lg-12">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              type="text"
                              placeholder=""
                              v-model="address"
                              id="address"
                            />

                            <span
                              class="lbl-label"
                              style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          "
                            >
                              <i class="material-icons" style="font-size: 20px"
                                >home</i
                              >
                            </span>
                            <label class="lbl-label"> Address </label>
                          </div>
                        </div>

                        <div class="col-sm-6 mt-3 col-lg-12">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              type="email"
                              placeholder=" "
                              v-model="email"
                              id="email"
                            />

                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >email</i
                              >
                            </span>
                            <label class="lbl-label">
                              Email
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12 mt-2">
                          <div class="form-group">
                            <label style="font-weight: 700" for="first">
                              Nationality
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state nationality"
                              class="text-capitalize"
                              v-model="nationality"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in nationalityArr"
                                :key="index"
                                :value="item.id"
                                class="text-capitalize"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-12 ">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              v-mask="'(99999) 9999999-9'"
                              type="text"
                              placeholder=" "
                              v-model="cnic"
                              :disabled="nationality != 1"
                              id="cnic"
                            />

                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >credit_card</i
                              >
                            </span>
                            <label class="lbl-label">
                              CNIC Number
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12 mt-2">
                          <div class="form-group">
                            <label style="font-weight: 700" for="first">
                              Qualification
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state qualification"
                              class="text-capitalize"
                              v-model="academicqualifications"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in qualificationArr"
                                :key="index"
                                :value="item.id"
                                class="text-capitalize"
                              >
                                {{item.title}}
                              </option>
                            </selectize>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12">
                          <div class="form-group">
                            <label style="font-weight: 700" for="first">
                              Department
                            </label>
                            <selectize
                              id="select-state department"
                              class="text-capitalize"
                              v-model="department"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in departmentArr"
                                :key="index"
                                :value="item.id"
                                class="text-capitalize"
                              >
                                {{item.title}}
                              </option>
                            </selectize>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12">
                          <div class="form-group">
                            <label style="font-weight: 700" for="first">
                              Designation
                            </label>
                            <selectize
                              id="select-state desgnation"
                              class="text-capitalize"
                              v-model="designation"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in designationArr"
                                :key="index"
                                :value="item.id"
                                class="text-capitalize"
                              >
                                {{item.title}}
                              </option>
                            </selectize>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-12">
                          <div style="padding-left: 5px;display: inline-flex;">
                            <label class="col-form-label">
                              Gender
                              <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                            </label>
                            <div style="margin: 7px 6px 2px 6px">
                              <vs-radio
                                v-model="gender"
                                vs-name="radios1"
                                vs-value="male"
                                id="male"
                                >Male</vs-radio
                              >
                            </div>
                            <div style="margin: 7px 6px 2px 6px">
                              <vs-radio
                                v-model="gender"
                                vs-name="radios1"
                                vs-value="female"
                                id="female"
                                >Female</vs-radio
                              >
                            </div>
                            <div style="margin: 7px 6px 2px 6px">
                              <vs-radio
                                v-model="gender"
                                vs-name="radios1"
                                vs-value="rather not say"
                                id="gender"
                                >Rather not say</vs-radio
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12 mt-3">
                          <div class="floating-label">
                            <input
                              class="floating-input form-control"
                              v-model="code"
                              type="text"
                              placeholder=" "
                              id="code"
                            />

                            <span
                              class="lbl-label"
                              style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;"
                                >code</i
                              >
                            </span>
                            <label class="lbl-label">
                              Employee Code (This will use as password)
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                          </div>
                        </div>
                        <!--end -->
                      </div>
                    </div>
                    <input type="hidden" v-model="userId" />
                    <input type="hidden" v-model="primaryUserId" />

                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-12 col-lg-12">
                          <!-- add button starts-->
                          <b-button
                            pill
                            type="submit"
                            class="save-btn"
                            variant="primary"
                            id="update"
                            >Update</b-button
                          >
                          <b-button
                            pill
                            v-if="!isForm"
                            @click="closeEditForm"
                            id="cancle"
                            variant="outline-info"
                            >Cancel</b-button
                          >
                          <!-- add button ends -->
                        </div>
                      </div>
                    </div>
                  </form>
                </template>
                <!-- // End of Edit form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Pagination from '../../../components/Pagination.vue'


export default {
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        searchQuery: "",
        isSidebar: false,
        whichSelect: 0,
        cnic: "",
        mobilenumber: "",
        passport: "",
        email: "",
        name: "",
        trainingId: "",
        valuesArray: [],
        updateTraining: [],
        radios1: "",
        gender: "",
        success: "",
        inValid: [],
        isForm: true,
        isFormData: false,
        tabIndex: 0,
        contact_person: "",
        contact_number: "",
        contact_email: "",
        isEditForm: "",
        address: "",
        tag: "",
        tags: [],
        role: "",
        rolesArr: [],
        roleuser: "",
        department: null,
        departmentArr: [],

        designation: null,
        designationArr: [],
        sessionByArray: [],
        textarea: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        endDate: "",
        colorx: "#1db952",

        trainingCheck: false,
        repeatedCheck: false,
        select1Normal: "",
        primaryUserId: "",
        userId: "",
        code: "",
        thematicareaSelected: "",
        countryArr: [],
        provinceArr: [],
        districtArr: [],
        nationalityArr: [],
        qualificationArr: [],
        items: [],
        nationality: '',
    }),
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Pagination,
        Selectize
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allTrainer();
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/countries/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.countryArr = response.data;
                // this.provinceArr=response.data;
            });

        // department
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.departmentArr = response.data;
            });
        //designation
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.designationArr = response.data;
            });
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainer/role/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                   localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                // this.rolesArr = response.data;
                this.role = response.data[0].id;
            });
        // Nationality
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/nationalities/get")
            .then(response => {

                this.closeLoading();
                this.nationalityArr = response.data;
            });

        // Qualification
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
            .then(response => {

                this.closeLoading();
                this.qualificationArr = response.data;
            });
    },

    methods: {
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainer/user/" + id + "/edit"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                       localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                       localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response) {
                        this.name = response.data.name;
                        this.code = response.data.trainer_user_id.code;
                        this.mobilenumber = response.data.mobile;
                        this.email = response.data.email;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passport;
                        this.userId = id;
                        this.gender = response.data.gender;
                        this.nationality = response.data.nationality;
                        this.address = response.data.address;
                        this.academicqualifications = response.data.academicqualifications;
                        this.designation = response.data.designation;
                        this.department = response.data.trainer_user_id.department_id;
                        this.primaryUserId = response.data.trainer_id_user;
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/trainer/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allTrainer();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .post(process.env.VUE_APP_BASE_PATH + "/trainer/show", {
                    "searchText": this.searchQuery,
                    "offSet": this.offSet,
                })
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                       localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                       localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data.rows;
                    this.totalCounts = response.data.totalCount;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.currentOffSet;
                })
                .catch(error => {
                    this.closeLoading();
                    if (error.response && error.response.status === 500) {
                        this.$toasted.global.errorMsg('Server Error: Please try again later');
                    } else {
                        this.$toasted.global.errorMsg('An error occurred while fetching trainers');
                    }
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        //Quick training
        quickRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }

            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }
            if (!this.code) {
                this.inValid.push("Password is required.");
            }
            var phone_no1 = this.mobilenumber;

            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }

            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainerAll/add", {
                        //insert User informatiion in user table
                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        nationality: this.nationality,
                        address: this.address,
                        academicqualifications: this.academicqualifications,
                        designation: this.designation,
                        department_name: this.department,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        type: "Quick Registration"
                    })
                    .then(response => {
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        //update form
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }

            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }
            if (!this.code) {
                this.inValid.push("Password is required.");
            }
            var phone_no1 = this.mobilenumber;

            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }

            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                let self = this;
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainer/update", {
                        //insert User informatiion in user table
                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        type: "Quick Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId,
                        nationality: this.nationality,
                        academicqualifications: this.academicqualifications,
                        address: this.address,
                        designation: this.designation,
                        department_name: this.department,
                    })

                    .then(response => {
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();

                            this.isForm = true;
                            this.isEditForm = false;
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.name = "";
            this.code = "";
            this.passport = "";
            this.gender = "";
            this.mobilenumber = "";
            this.email = "";
            this.cnic = "";
            this.nationality = "";
            this.academicqualifications = "";
            this.address = "";
            this.department = "";
            this.designation = "";
        },
        successUpload() {
            this.$vs.notify({
                color: "primary",
                title: "Upload Success",
                text: "Your file is uploaded Successfully."
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.allTrainer();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.allTrainer();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.allTrainer();
        },
        filterData() {
            this.currentPage = 1
            this.offSet = 0
            this.allTrainer();
        },
        clearSearch() {
            this.currentPage = 1
            this.offSet = 0
            this.searchQuery = ""
            this.allTrainer();
        },
        callSearch() {
            if (this.searchQuery.length == 0) {
                this.currentPage = 1
                this.offSet = 0
                this.searchQuery = ""
                this.allTrainer();
            }
        }

    },

};
</script>

<style scoped>
@media only screen and (max-width: 992px) {
    .question-bank-row {
        height: 92vh;
         overflow: scroll !important;
    }

    .create-question-scroll {
        height: initial !important;
        overflow: hidden !important;
    }

    .show-question-scroll {
        height: initial !important;
        overflow: hidden !important;
    }
}

.question-bank-row {
    height: 92vh;
    overflow: hidden;
}

.create-question-scroll {
    height: 100vh;
    overflow: auto;
}

.show-question-scroll {
    height: 92vh;
    overflow: auto;
}

#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.mt-45 {
    margin-top: 45px !important;
}

button:focus {
    outline: transparent !important;
    outline: transparent -webkit-focus-ring-color !important;
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #ffffff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.previous-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: left;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #fff;
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

.add-btn {
    font-size: 25px;
    color: rgba(7, 167, 225, 0.61);
    cursor: pointer;
}

.delete-btn {
    font-size: 25px;
    color: rgba(255, 0, 0, 0.78);
    cursor: pointer;
}

.page-count {
    text-align: end;
    font-size: 15px;
    color: #06a6e0;
}
</style>
